import type { UseMutationOptions } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import { client } from '@/shared/http/client';
import type {
  GetUserInfoMutationRequest,
  GetUserInfoMutationResponse,
} from '../../types/get-user-info';
import { ENDPOINT } from '../../types/get-user-info';

/**
 * @description Obtém informações do usuário autenticado
 * @summary Buscar informações do usuário
 * {@link /api/get-user-info}
 */
export async function getUserInfo(body: GetUserInfoMutationRequest) {
  const response = await client.post(ENDPOINT, { json: body });
  return response.json<GetUserInfoMutationResponse>();
}

/**
 * @description Obtém informações do usuário autenticado
 * @summary Buscar informações do usuário
 */
export function useGetUserInfo(
  options?: UseMutationOptions<GetUserInfoMutationResponse, Error, GetUserInfoMutationRequest>
) {
  return useMutation<GetUserInfoMutationResponse, Error, GetUserInfoMutationRequest>({
    ...options,
    mutationFn: getUserInfo,
  });
}
